import React from 'react';
import { FaCrown, FaMapMarkerAlt } from 'react-icons/fa';
import styles from './brunafurnielstore.module.scss';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import PerfilLogo from './src/perfil.png';

const BTN_TEXT = '#EDE5D4';

/** Ajuste para os links reais da marca */
const INSTAGRAM_URL = 'https://www.instagram.com/brunafurnielstore?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==';
const WHATSAPP_NUMBER = '5517996782065';
const WHATSAPP_MSG = 'Olá! Vim pelo link na bio e gostaria de mais informações.';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;
const VIP_URL = 'https://chat.whatsapp.com/KJtYABOSxpaHNXhhFqOmfb?s=sw&p=i&ilr=4'; // TODO: trocar quando tiver o link do grupo VIP
const MAPS_URL = 'https://maps.app.goo.gl/7Z9uAYUoPYy9fkJ69';

const Brunafurnielstore: React.FC = () => {
    return (
        <div className={styles.brunafurnielstore}>
            <div className={styles['body-thunder']}>
                <div className={styles['container-thunder']}>
                    <div className={styles.profileStack}>
                        <img
                            src={PerfilLogo}
                            className={styles['img-perfil']}
                            alt="Bruna Furniel Store"
                        />
                        <div className={styles.links}>
                            <a
                                href={INSTAGRAM_URL}
                                className={styles.linkButton}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <InstagramIcon height="24" color={BTN_TEXT} />
                                </span>
                                <span className={styles.linkLabel}>INSTAGRAM</span>
                            </a>
                            <a
                                href={WHATSAPP_URL}
                                className={styles.linkButton}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <WhatsappIcon height="30" color={BTN_TEXT} />
                                </span>
                                <span className={styles.linkLabel}>WHATSAPP</span>
                            </a>
                            <a
                                href={VIP_URL}
                                className={styles.linkButton}
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <FaCrown size="22" color={BTN_TEXT} />
                                </span>
                                <span className={styles.linkLabel}>GRUPO VIP</span>
                            </a>
                            <a
                                href={MAPS_URL}
                                className={styles.linkButton}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <FaMapMarkerAlt size="22" color={BTN_TEXT} />
                                </span>
                                <span className={styles.linkLabel}>LOCALIZAÇÃO</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Brunafurnielstore;
